import { LoginSettings } from '@anecdotes/api-contracts';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class LoginSettingsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = window['__AnPlatformConfiguration__'].identityApi.baseUrl;

  getLoginSettings(): Observable<LoginSettings> {
    return this.httpClient.get<LoginSettings>(`${this.baseUrl}/customer/login_settings`);
  }

  updateLoginSettings(loginSettings: LoginSettings): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/customer/login_settings`, loginSettings);
  }
}
